export default "__VITE_ASSET__bd7c6751__"